module.exports = __webpack_public_path__ + "static/media/scan.40396842.m4a";